import { atom } from "recoil";
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist({
    key: 'respondent_mpu_persist', // this key is using to store data in local storage
    storage: localStorage, // configurate which stroage will be used to store the data
})

const user_data = atom({
    key: 'user_data',
    default: {},
    effects_UNSTABLE: [persistAtom],
})

const user_login_state = atom({
    key: 'user_login_state',
    default: false,
    effects_UNSTABLE: [persistAtom],
})

const user_role = atom({
    key: 'user_role',
    default: "",
    effects_UNSTABLE: [persistAtom]
})

const user_id = atom({
    key: 'user_id',
    default: 0,
    effects_UNSTABLE: [persistAtom]
})

const w_labels = atom({
    key: 'w_labels',
    default: [],
    effects_UNSTABLE: [persistAtom]
})

const langs = atom({
    key: 'langs',
    default: [],
    effects_UNSTABLE: [persistAtom]
})

const chosen_lang = atom({
    key: 'chosen_lang',
    default: {
        language: 'English',
        code: 'en',
        flag: 'enf.jpg'
    },
    effects_UNSTABLE: [persistAtom]
})

const show_header = atom({
    key: 'show_header',
    default: false,
    effects_UNSTABLE: [persistAtom]
})

const redir = atom({
    key: 'redir',
    default: "lang",
    effects_UNSTABLE: [persistAtom]
})

const surveys = atom({
    key: 'surveys',
    default: [],
    effects_UNSTABLE: [persistAtom]
})

const _questions = atom({
    key: '_questions',
    default: [],
    effects_UNSTABLE: [persistAtom]
})

const _options = atom({
    key: '_options',
    default: {},
    effects_UNSTABLE: [persistAtom]
})

const _questionsinprogress = atom({
    key: '_questionsinprogress',
    default: [],
    effects_UNSTABLE: [persistAtom]
})

const _surveyredirect = atom({
    key: '_surveyredirect',
    default: "sinstruction",
    effects_UNSTABLE: [persistAtom]
})

const _surveystatus = atom({
    key: '_surveystatus',
    default: "surveyinstructions",
    effects_UNSTABLE: [persistAtom]
})

const _online = atom({
    key: '_online',
    default: true,
    effects_UNSTABLE: [persistAtom]
})

const _lastlogin = atom({
    key: '_lastlogin',
    default: Object,
    effects_UNSTABLE: [persistAtom]
})

const _logindiff = atom({
    key: '_logindiff',
    default: 0
})

const _offlineready = atom({
    key: '_offlineready',
    default: false,
})

const _answers = atom({
    key: '_answers',
    default: [],
    effects_UNSTABLE: [persistAtom]
})

const _firstrun_howto = atom({
    key: '_firstrun_howto',
    default: "false",
    effects_UNSTABLE: [persistAtom]
})

const _firstrun_sinstruction = atom({
    key: '_firstrun_sinstruction',
    default: false,
    effects_UNSTABLE: [persistAtom]
})

const _totaltime = atom({
    key: '_totaltime',
    default: 0,
    effects_UNSTABLE: [persistAtom]
})

const _enablesurvey = atom({
    key: '_enablesurvey',
    default: true,
    effects_UNSTABLE: [persistAtom]
})

const _orglogo = atom({
    key: '_orglogo',
    default: {},
    effects_UNSTABLE: [persistAtom]
})

const _hasorglogo = atom({
    key: '_hasorglogo',
    default: false,
    effects_UNSTABLE: [persistAtom]
})

const _otpcountry = atom({
    key: '_otpcountry',
    default: false,
    effects_UNSTABLE: [persistAtom]
})

export { user_data, user_login_state, user_role, user_id, w_labels, langs, chosen_lang, show_header, redir, surveys, _options, _questions, _questionsinprogress, _surveyredirect, _surveystatus, _online, _lastlogin, _logindiff, _offlineready, _answers, _firstrun_howto, _firstrun_sinstruction, _totaltime, _enablesurvey, _orglogo, _hasorglogo, _otpcountry } 